import './App.css';
//import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { HashRouter as Router, Switch, Route, Link } from "react-router-dom";

import InventarioPage from './pages/InventarioPage';
import ClienteManager from './pages/Clientes';
import ProdutoManager from './pages/Produtos';
import ListClient from './pages/ListClient';
import ListProduct from './pages/ListProduct';

function App() {
  return (
    <><Router>
      <Switch>
        <Route exact path="/" exact component={InventarioPage} />
        <Route exact path="/clientes" exact component={ListClient} />
        <Route exact path="/clientes/add" exact component={ClienteManager} />
        <Route exact path="/produtos" exact component={ListProduct} />
        <Route exact path="/produtos/add" exact component={ProdutoManager} />
      </Switch>
    </Router>
    </>
  );
}

export default App;
